import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateResourceRequest,
  DeleteResourceRequest,
  UpdateResourceRequest,
  ViewResourcesByTypeRequest
} from './resource.types';

import {
  requestCreateResource,
  requestDeleteResource,
  requestUpdateResource,
  requestViewResourcesByType
} from './resource.actions';

export const useResourceApi = () => {
  const dispatch = useDispatch();

  const createResource = useCallback(
    (requestData: CreateResourceRequest, onSuccess?: () => void) => {
      dispatch(requestCreateResource({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateResource = useCallback(
    (requestData: UpdateResourceRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateResource({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteResource = useCallback(
    (requestData: DeleteResourceRequest, onSuccess?: () => void) => {
      dispatch(requestDeleteResource({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewResourcesByType = useCallback(
    (requestData: ViewResourcesByTypeRequest, onSuccess?: () => void) => {
      dispatch(requestViewResourcesByType({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      createResource,
      updateResource,
      deleteResource,
      viewResourcesByType
    }),
    [createResource, updateResource, deleteResource, viewResourcesByType]
  );
};
